import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { CanActivate, Router, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DataTableModule } from "angular2-datatable";
import { BsModalModule } from 'ng2-bs3-modal';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

//components
import { TopicComponent } from '../app/topic/topic'
import { SubTopicComponent } from '../app/sub-topic/sub-topic'
import { QuestionComponent } from '../app/question/question'
import { WordImportComponent } from '../app/word-import/word-import'

import { TopicService } from './shared/services/topic.service';
import { SubTopicService } from './shared/services/sub-topic.service';
import { QuestionService } from './shared/services/question.service';

@NgModule({
  declarations: [
    AppComponent,
    TopicComponent,
    SubTopicComponent,
    QuestionComponent,
    WordImportComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BsModalModule,
    DataTableModule,
    FormsModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    RouterModule.forRoot([
      //{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'topics', component: TopicComponent },
      { path: 'sub-topics', component: SubTopicComponent },
      { path: 'questions', component: QuestionComponent },
      { path: 'questions/:questionId/:topicId/:subTopicId', component: QuestionComponent },
      { path: 'questions/:topicId/:subTopicId', component: QuestionComponent },
      { path: 'questions/:searchTerm', component: QuestionComponent },
      { path: 'word-import', component: WordImportComponent }
    ])
  ],
  bootstrap: [AppComponent],
  providers: [TopicService, SubTopicService, QuestionService]
})
export class AppModule { }
